require('./bootstrap');

$.fn.redraw = function () {
  return this.hide(0, function () {
    $(this).show();
  });
};

$.fn.inView = function () {
  //Window Object
  var win = $(window); //Object to Check

  obj = $(this); //the top Scroll Position in the page

  var scrollPosition = win.scrollTop(); //the end of the visible area in the page, starting from the scroll position

  var visibleArea = win.scrollTop() + win.height(); //the end of the object to check

  var objEndPos = obj.offset().top + obj.outerHeight();
  return visibleArea >= objEndPos && scrollPosition <= objEndPos;
};

$.expr[':'].regex = function (elem, index, match) {
  var matchParams = match[3].split(','),
      validLabels = /^(data|css):/,
      attr = {
    method: matchParams[0].match(validLabels) ? matchParams[0].split(':')[0] : 'attr',
    property: matchParams.shift().replace(validLabels, '')
  },
      regexFlags = 'ig',
      regex = new RegExp(matchParams.join('').replace(/^\s+|\s+$/g, ''), regexFlags);
  return regex.test(jQuery(elem)[attr.method](attr.property));
}; // function to determine minimum height required for the payform inside an iframe


window.getHeightRequiredForPayform = function () {
  var body = document.body;
  var html = document.documentElement;
  return Math.max(body.clientHeight, body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
}; // always send CSRF token with each ajax request


$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});
window.cspNonce = $('meta[name="csp-nonce"]').attr('content');
$(document).ready(function () {
  $('[data-toggle="popover"]').popover();
  $('[data-toggle="tooltip"]').tooltip(); // toggle button to show details of a webhook

  $('a.webhook-attempt-details').click(function () {
    $(this).parents('tr').next().fadeToggle();
    return false;
  }); // confirm dialog for destructive actions

  $('*[data-confirm]').click(function (event) {
    if (!confirm($(this).data('confirm'))) {
      event.preventDefault();
    }
  });
  $('#logout-button').on('click', function (event) {
    event.preventDefault();
    $('#logout-form').submit();
  });
});